import {TopNavBarButton} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButton';
import SettingsIcon from '@material-ui/icons/Settings';
import React from 'react';

export const SettingsPanelButton = React.memo(({btnDef, ...props}) => (
	<TopNavBarButton
		{...props}
	>
		<SettingsIcon fontSize={'small'}/>
		{btnDef.label}
	</TopNavBarButton>
));